import styled from "styled-components";
import { useState, useContext, useEffect } from "react";
import { OrgTreeContext } from "../../../Contexts/OrgTreeContext";
import { generateDateArray } from "../../../Helpers/TimeFunctions";
import { findNodeById } from "../../../Helpers/OrgTreeFunctions";

const ReportCheckWrapper = styled.div`
  grid-area: report-check;
  border-radius: 10px;
  width: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0px 0px 15px 3px rgba(197, 197, 197, 0.201);

  h2 {
    text-transform: capitalize;
    margin-bottom: 10px;
    font-size: 15px;
  }
  p {
    align-self: flex-start;
    font-size: 12px;
    font-weight: 300;
  }

  .sumbissions-table {
    display: grid;
    justify-content: center;
    grid-template-columns: max-content auto;
    grid-template-areas:
      "nameColumn statusColumn"
      "nameColumn statusColumn";
    width: 100%;
  }
  .sumbissions-table p {
    height: 20px;
    width: 100%;
    border-bottom: 1px solid var(--accent-color-dark);
  }
  #nameColumn {
    grid-area: nameColumn;
    display: grid;
    text-align: center;
    margin-bottom: 5px;
  }

  #nameColumn {
    display: flex;
    flex-direction: column;
    width: max-content;
  }
  #nameColumn p {
    padding-left: 5px;
    text-align: left;
    line-height: 19px;
  }
  #statusColumn {
    grid-area: statusColumn;
    display: flex;
    flex-direction: column;
    overflow: scroll;
  }
  #datesRow {
    display: flex;
    flex-direction: row;
    grid: 10px;
    width: fit-content;
  }
  #statusGrid {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  #statusRow {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: fit-content;
  }
  #statusRow p,
  #datesRow p {
    width: 80px;
    text-align: center;
  }
`;

export default function ReportSubmissionCheck(props: Props) {
  const orgTree = useContext(OrgTreeContext);
  const [reportSumbissions, setReportSubmissions] = useState<
    ReportSubmissions[] | null
  >(null);

  useEffect(() => {
    if (
      props.relevantReports &&
      props.selectedNode.children &&
      props.dates &&
      orgTree
    ) {
      const nodeInOrgTree =
        findNodeById([orgTree], props.selectedNode.teamId) ?? null;
      const reportSubmissions: ReportSubmissions[] = [];
      const teamMembers = nodeInOrgTree?.children?.map((child) => {
        if (
          child.teamType === "volunteer" ||
          child.teamType === "pastoralCare" ||
          child.teamType === "churchStaff"
        ) {
          return child;
        }
      });

      teamMembers?.forEach((member) => {
        if (member) {
          const timeIntervals = generateDateArray(
            props.dates[0],
            props.dates[1]
          );
          const reportSubmissionsForThisMember: ReportSubmissions = {
            name: member.label,
            checks: timeIntervals.map((interval) => {
              const reports = props.relevantReports?.filter((report) => {
                if (
                  member.teamId === "387522743584433" &&
                  report.userId === "387522743584433" &&
                  new Date(report.reportPeriodDate) >=
                    new Date(interval.startDate) &&
                  new Date(report.reportPeriodDate) <=
                    new Date(interval.endDate) 
                ) {
                  console.log(report);
                }
                return (
                  new Date(report.reportPeriodDate) >=
                    new Date(interval.startDate) &&
                  new Date(report.reportPeriodDate) <=
                    new Date(interval.endDate) &&
                  member.teamId === report.userId
                );
              });
              return {
                date: interval.startDate,
                reports: reports ? reports.length : 0,
              };
            }),
          };
          reportSubmissions.push(reportSubmissionsForThisMember);
        }
      });
      setReportSubmissions(reportSubmissions);
    }
  }, [props.relevantReports, props.selectedNode, props.dates]);

  return (
    <>
      {reportSumbissions && reportSumbissions[0] && (
        <ReportCheckWrapper>
          <h2>Report Submissions</h2>
          <div className="sumbissions-table">
            <div id="nameColumn">
              <p>Team members</p>
              {reportSumbissions &&
                reportSumbissions.map((submission, index) => {
                  return <p key={index}>{submission.name}</p>;
                })}
            </div>
            <div id="statusColumn">
              <div id="datesRow">
                {reportSumbissions &&
                  reportSumbissions[0] &&
                  reportSumbissions[0].checks.map((check, index) => {
                    const dateString = new Date(
                      check.date
                    ).toLocaleDateString();
                    return <p key={index}>{dateString}</p>;
                  })}
              </div>
              <div id="satusGrid">
                {reportSumbissions &&
                  reportSumbissions.map((reportSubmisson, index) => {
                    return (
                      <div key={index} id="statusRow">
                        {reportSubmisson.checks.map((check, index) => {
                          return check.reports ? (
                            <p key={index}>✅</p>
                          ) : (
                            <p key={index}>❌</p>
                          );
                        })}
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </ReportCheckWrapper>
      )}
    </>
  );
}

interface Props {
  dates: Date[];
  selectedNode: OrgTreeItem;
  relevantReports: ReportData[] | null;
}
